export default {
    webtitle: "Firma a kontakty - DOFFERO®",
    information_text_1: "Informace byly uloženy.",

    firmakontakt_text_1: "Firma a kontakty",
    firmakontakt_text_2: "Nastav si údaje, které se týkají tvé firmy a budou se zobrazovat v tvých nabídkách. Tyto info můžeš kdykoli změnit.",
    firmakontakt_text_3: "Základní údaje",
    firmakontakt_text_4: "Logo a razítko",
    firmakontakt_text_5: "Kontaktní osoba",
    firmakontakt_text_6: "Základní údaje ke kontaktní osobě, které se zobrazí v nabídce. Můžeš je změnit i v nabídce.",
    firmakontakt_text_7: "Firemní údaje",
    firmakontakt_text_8: "Některé údaje dokážeme vyplnit automaticky. Zadej IČO nebo název firmy.",
    firmakontakt_text_9: "Sociální sítě",
    firmakontakt_text_10: "Nastav si odkazy na tvoje sociální sítě a ty se zobrazí v patičce nabídky",
    firmakontakt_text_11: "Šablony nabídek",
    firmakontakt_text_12: "Viditelné pouze pro admin uživatele",
    firmakontakt_text_13: "Uložit",


    firemneudaje_text_1: "Název společnosti",
    firemneudaje_text_2: "IČO",
    firemneudaje_text_3: "DIČ",
    firemneudaje_text_4: "IČ DPH",
    firemneudaje_text_5: "ULICE A ČÍSLO sídla firmy",
    firemneudaje_text_6: "PSČ sídla firmy",
    firemneudaje_text_7: "MĚSTO sídla firmy",

    kontaktnaosoba_text_1: "jméno kontaktní osoby",
    kontaktnaosoba_text_2: "Telefonní číslo",
    kontaktnaosoba_text_3: "kontaktní E-MAIL",
    kontaktnaosoba_text_4: "Tento e-mail může být jiný než tvůj přihlašovací e-mail. Používá se jako kontaktní e-mail v nabídce.",

    logo_text_1: "Vlož logo přetažením",
    logo_text_2: "Vlož logo přetažením",
    logo_text_3: "Vlož logo přetažením",
    logo_text_4: "nebo",
    logo_text_5: "Vybrat logo",
    logo_text_6: "Smazat",
    logo_text_7: "Stáhnout",
    logo_text_8: "Opravdu chcete smazat logo?",
    logo_text_9: "Je možné nahrát jen jedno logo. Prosím, nejprve smažte původní.",
    logo_text_10: "Pouze {extensions} soubory mohou být nahrány.",
    logo_text_11: "{name} je příliš velký! Prosím, vyberte soubor do velikosti {fileMaxSize} MB.",

    nazovslug_text_1: "Název tvé firmy / ZNAČKY",
    nazovslug_text_2: "Podle tohoto názvu se vygeneruje URL adresa tvých nabídek, ale můžeš to změnit.",
    nazovslug_text_3: "Tvůj odkaz na cenovou nabídku bude vypadat takto:",

    signature_text_0: "razítko / Podpis",
    signature_text_1: "Vlož <b>podpis</b> nebo <b>razítko</b> přetažením <br> nebo <span class='nahraj'>nahraj podpis</span>",
    signature_text_2: "Vlož <b>podpis</b> nebo <b>razítko</b> přetažením <br> nebo <span class='nahraj'>nahraj podpis</span>",
    signature_text_3: "Vlož <b>podpis</b> nebo <b>razítko</b> přetažením <br> nebo <span class='nahraj'>nahraj podpis</span>",
    signature_text_4: "",
    signature_text_5: "",
    signature_text_6: "Smazat",
    signature_text_7: "Stáhnout",
    signature_text_8: "Opravdu chcete smazat podpis?",
    signature_text_9: "Je možné nahrát jen jeden podpis. Prosím, nejprve smažte původní.",
    signature_text_10: "Pouze {extensions} soubory mohou být nahrány.",
    signature_text_11: "{name} je příliš velký! Prosím, vyberte soubor do velikosti {fileMaxSize} MB.",

    webtel_text_1: "Webová stránka firmy",
    webtel_text_2: "Telefonní číslo",
    webtel_text_3: "Jsem plátce DPH",
    webtel_text_4: "Nastav si, zda jsi plátce DPH, abychom do tvých nabídek dávali správné ceny.",
    webtel_text_5: "Nastavit ceny s ",
    webtel_text_6: " % DPH",
}
